import { Spacing } from "@bonusx-global/bx-design-system";
import { BellExclamationDuotone } from "@bonusx-global/bx-icons";
import { styled } from "@mui/material";

export const BigBellExclamationDuotone = styled(BellExclamationDuotone)({
  height: Spacing["3000"],
  width: Spacing["3000"],
});
